import React, {useEffect, useState} from 'react'
import Navbar from "../../../components/main/Navbar";
import Title from "../../../components/atoms/Title";
import ButtonT from "../../../components/atoms/ButtonT";
import InputGroup from "../../../components/atoms/InputGroup";
import {useConfigContext} from "../ConfigContext";
import ViaqSelectBox from "../../../components/atoms/ViaqSelectBox";
import AcceptUpdateModal from "./AcceptUpdateModal";
import {showToastByIsSuccess} from "../../../tools/tools";

const ReleaseApplicationSection = () => {
    const {openModal, release} = useConfigContext()
    const updateStatus = [
        {
            label: "اپدیت عادی",
            value: false

        },
        {
            label: "اپدیت ضروری",
            value: true
        }


    ];


    const [updateState, setUpdateState] = useState({
        version: "",
        isForce: false
    })


    return (
        <>
            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px "
                dir="rtl">
                <div className="flex flex-row justify-between items-center h-10  ">
                    <div className="flex flex-row ">
                        <Title text="بروزرسانی اپلیکیشن"/>
                    </div>

                    <ButtonT
                        text="ثبت بروزرسانی"
                        onClick={() => {
                            if (updateState.version !== "" && updateState.version !== release.relaseNumber) {
                                openModal('update', updateState);

                            }else{
                                showToastByIsSuccess(false,"نسخه جدید را وارد کنید")
                            }

                        }}
                        borderBlue="border-blue border-1"
                    />
                </div>
                <div className="flex flex-row justify-start  gap-5 mt-25">
                    <div className={"w-1/3"}>
                        <InputGroup
                            label={"نسخه اپلیکیشن"}
                            placeholder={"مثلا 1.2.3"}
                            icon={false}
                            onchangeAble={true}
                            val={release.relaseNumber}
                            disabled={false}
                            readOnly={false}
                            onchange={(event) => {
                                setUpdateState(prevState => ({
                                    ...prevState,
                                    version: event.target.value
                                }))
                            }}
                        />

                    </div>

                    <div className={"flex flex-col w-1/3"}>
                        <label
                            htmlFor=""
                            className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                            {"نوع اپدیت"}
                        </label>

                        <ViaqSelectBox
                            iconName={"export"}
                            defaultValue={updateStatus[0].label}
                            showIcon={false}
                            placeholder={"نوع اپدیت رو مشخص کنید"}
                            onChange={(data) => {
                                if (data) {
                                    setUpdateState(prevState => ({
                                        ...prevState,
                                        isForce: data[0].value
                                    }))

                                }

                            }}

                            values={updateStatus}

                        />
                    </div>
                </div>
                <AcceptUpdateModal/>

            </div>
        </>
    )
}

export default ReleaseApplicationSection
